<template>
    <span class="tooltip" tabindex="0">
        <SvgIcon type="icon_tooltip" class="tooltip__icon" alt="Tooltip"/>
        <span class="tooltip__textWrapper">
            <span class="tooltip__text">
                {{ text }}
            </span>
        </span>
    </span>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'Tooltip',
    components: { SvgIcon },
    props: {
        text: {
            type: String
        }
    }
}
</script>
